import { render, staticRenderFns } from "./HeaderTips.vue?vue&type=template&id=1e9df0d6&scoped=true&"
import script from "./HeaderTips.vue?vue&type=script&lang=js&"
export * from "./HeaderTips.vue?vue&type=script&lang=js&"
import style0 from "./HeaderTips.vue?vue&type=style&index=0&id=1e9df0d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e9df0d6",
  null
  
)

export default component.exports